import { SetRoutes } from 'components';
import routes from './routes';
const SiteCategoriesPages = () => {
  return (
    <>
      <SetRoutes routes={routes} />
    </>
  );
};

export default SiteCategoriesPages;
